export default __webpack_public_path__ + "assets/673b2292387cd03758644289fa99a4d1.png";